import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { FeeRecommendationChangeType, REMOVAL_PROPOSED_LABEL } from 'constants/feeRecommendations';
import { getChangedBuckets } from 'utils/feeRecommendations';

import { deltaRowStyles } from './FeeRecommendationChanges.styles';

const FeeRecommendationChanges = ({ item }) => {
  if (item.changeType === FeeRecommendationChangeType.REMOVE) {
    return (
      <Typography color="text.secondary" variant="regular14">
        {REMOVAL_PROPOSED_LABEL}
      </Typography>
    );
  }

  return getChangedBuckets(item).map(({ label, original, proposed }) => (
    <Box key={label} sx={deltaRowStyles}>
      <Typography color="text.secondary" variant="regular14">
        {`${label}:`}
      </Typography>
      <Typography color="text.secondary" variant="regular14">
        {`${original} → ${proposed}`}
      </Typography>
    </Box>
  ));
};

FeeRecommendationChanges.propTypes = {
  item: PropTypes.object.isRequired,
};

export default memo(FeeRecommendationChanges);
